module.exports = __webpack_public_path__ + "summernote.6e72b5d181d3c1793e71.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/summernote/0.8.9/font/summernote.eot
// module id = 801
// module chunks = 8